<template>
    <div :class="['content', !nState ? 'no_state' : '']">
        <div
            class="pdfimg"
            v-for="(item, index) in arrPdfImg"
            :key="index"
            @click="openLook(index)"
        >
            <img v-lazy="item" alt="" />
        </div>
        <div class="share_mark" v-if="bShow">
            <div class="share_tips">
                <div class="share_title">设置有效期</div>
                <div class="validity">
                    方案书预览有效期：<span>{{ num }}天</span>
                </div>
                <div class="progress">
                    <van-slider
                        bar-height="8"
                        :step="100 / 6"
                        button-size="30"
                        v-model="value"
                        @input="onInput"
                        active-color="#6176e8"
                        inactive-color="#DBDBDB"
                    ></van-slider>
                </div>
                <div class="text">*有效期默认为7天*</div>
                <div class="btn">
                    <div @click.stop="comen">确认</div>
                    <div @click.stop="canler">取消</div>
                </div>
            </div>
        </div>
        <!-- 分享按钮 -->
        <div class="borrom_btn" v-if="!shareKey">
            <div @click="getShare">分享</div>
            <div @click="download">下载</div>
        </div>
        <!-- 微信环境请用右上角分享 -->
        <div class="wxshare" v-if="wxShareShow" @click="wxShareShow = false">
            <div class="wxContent">
                <img src="@/assets/images/right_jiao_icon.png" alt="" />
                <div class="wxTips">微信环境请点击右上角分享</div>
            </div>
        </div>
        <!-- 当前pdf是否有效 -->
        <div class="overdue" v-if="!nState">
            <div class="overdue_tips">
                <div class="overdue_title">温馨提示</div>
                <div class="overdue_text">
                    此PDF已过期，截至于<span>{{ endTime | getTime }}</span>
                </div>
            </div>
        </div>
        <!-- 预览图片 -->
        <van-image-preview
            v-model="pdfShow"
            :startPosition="lookImgIndex"
            :images="arrPdfImg"
            @change="lookChang"
        >
            <template v-slot:imgIndex>第{{ imgIndex }}页</template>
        </van-image-preview>
        <!-- 分享弹窗 -->
        <share :bShowNrom.sync="bShowNrom" :confit="confit"></share>
    </div>
</template>
<script>
import oDetail from "@/js/detail";
import share from "./components/share/index"; //分享
import { getWxSingleConfig } from "@/js/wx.js";
export default {
    components: {
        share,
    },
    data() {
        return {
            bShowNrom: false,
            pdfShow: false, //查看图片
            bShow: false,
            lookImgIndex: 0,
            imgIndex: 0,
            value: 100, //初始化值
            nValue: 100,
            num: 7, //初始化值
            nNum: 7, //确认值
            bComen: false,
            nKey: "", //分享key
            nState: 1, //是否有效
            arrPdfImg: [], //pdf图片
            endTime: "", //截至时间
            wxShareShow: false,
            confit: {},
            locatHref: "", //pdf连接
            address: "", //地址
            shareKey: "", //分享进来的key
        };
    },
    filters: {
        // 使用es6的padStart()方法来补0
        getTime(timestamp) {
            let zhTime = timestamp.replace(/\-/g, "/");
            let time = new Date(zhTime);
            let year = time.getFullYear();
            const month = (time.getMonth() + 1).toString().padStart(2, "0");
            const date = time.getDate().toString().padStart(2, "0");
            const hours = time.getHours().toString().padStart(2, "0");
            const minute = time.getMinutes().toString().padStart(2, "0");
            const second = time.getSeconds().toString().padStart(2, "0");

            return (
                year +
                "年" +
                month +
                "月" +
                date +
                "日" +
                hours +
                "时" +
                minute +
                "分"
            );
        },
    },
    created() {
        $init(() => {
            this.shareKey = this.$route.query.nKey;
            let reportData = {
                report_id: this.$route.query.reportId,
            };
            this.$store.commit("loadSwitch", true);
            oDetail.getReportinfo(reportData).then((res) => {
                let arrPdfImg = [];
                res.result.pdf_img.forEach((it) => {
                    arrPdfImg.push(it.img_url);
                });
                this.locatHref = res.result.pdf;
                this.arrPdfImg = arrPdfImg;
                this.address = res.result.address;
                this.wxShare();
                this.$store.commit("loadSwitch", false);
            });
        });
    },
    methods: {
        wxShare() {
            if (this.$route.query.nKey) {
                oDetail
                    .getPdfShareInfo({ key: this.$route.query.nKey })
                    .then((res) => {
                        this.nKey = res.result.key;
                        let confit = {
                            share_friend_title: `请查阅您的艾暖通消息`,
                            share_friend_desc:
                                this.address +
                                "AI-LiNK冷暖风水专业集成系统定制方案",
                            share_img_url:
                                "https://aotest-lottery.iwxapi.com/core/images2020/watersystem/ant/share_img.png",
                            share_link: `${window.location.protocol}//${window.location.host}${window.location.pathname}?reportId=${this.$route.query.reportId}&nKey=${this.nKey}`,
                        };
                        this.confit = confit;
                        getWxSingleConfig(confit);
                        let keyTime = res.result.expire_at.replace(/\-/g, "/");
                        let dateEndTime = new Date(keyTime).getTime();
                        let currentTime = new Date().getTime();
                        if(currentTime>=dateEndTime){
                            this.nState = 0;
                        }else{
                            this.nState = 1;
                        }
                        this.endTime = res.result.expire_at;
                        wx.ready(() => {
                            wx.hideOptionMenu();
                        });
                    });
            } else {
                //获取默认7天的key
                let data = {
                    report_id: this.$route.query.reportId,
                    day: 7,
                    type: 1,
                };
                oDetail.getPdfShare(data).then((res) => {
                    this.nKey = res.result.key;
                    let confit = {
                        share_friend_title: `请查阅您的艾暖通消息`,
                        share_friend_desc:
                            this.address +
                            "AI-LiNK冷暖风水专业集成系统定制方案",
                        share_img_url:
                            "https://aotest-lottery.iwxapi.com/core/images2020/watersystem/ant/share_img.png",
                        share_link: `${window.location.protocol}//${window.location.host}${window.location.pathname}?reportId=${this.$route.query.reportId}&nKey=${this.nKey}`,
                    };
                    this.confit = confit;
                    getWxSingleConfig(confit);
                });
            }
        },
        //点击下载
        download() {
            window.location.href = this.locatHref;
        },
        openLook(index) {
            this.pdfShow = true;
            this.lookImgIndex = index;
        },
        lookChang(index) {
            this.imgIndex = index;
        },
        getShare() {
            if (this.$route.query.nKey) {
                this.$toast("禁止分享~");
                return false;
            }
            this.$dialog.confirm({
                message: '请选择该方案书分享方式',
                confirmButtonText:'永久分享',
                cancelButtonText:'期限分享',
                confirmButtonColor:'#023f88',
                closeOnClickOverlay:true,
            })
            .then((res) => {
                let confit = {
                    share_friend_title: `请查阅您的艾暖通消息`,
                    share_friend_desc:
                        this.address + "AI-LiNK冷暖风水专业集成系统定制方案",
                    share_img_url:
                        "https://aotest-lottery.iwxapi.com/core/images2020/watersystem/ant/share_img.png",
                    share_link: `${window.location.protocol}//${window.location.host}${window.location.pathname}?reportId=${this.$route.query.reportId}`,
                };
                this.confit = confit;
                getWxSingleConfig(confit);
                if (this.$storage.getStorage("is_wechat") == 1) {
                    // 微信环境下
                    this.wxShareShow = true;
                } else if (this.$storage.getStorage("is_wechat") == 6) {
                    // 企业微信环境下
                    this.bShowNrom = true;
                }
                // on confirm
            }).catch((err) => {
                this.bShow = true;
            })
        },
        onInput(e) {
            this.num = (e / (100 / 6) + 1).toFixed(0);
        },
        comen() {
            if (this.nNum != this.num) {
                this.nNum = this.num;
                this.nValue = this.value;
                this.bComen = true;
            }
            this.bShow = false;
            let data = {
                report_id: this.$route.query.reportid,
                day: this.nNum,
                type: 1,
            };
            this.$store.commit("loadSwitch", true);
            oDetail.getPdfShare(data).then((res) => {
                this.nKey = res.result.key;
                let confit = {
                    share_friend_title: `请查阅您的艾暖通消息`,
                    share_friend_desc:
                        this.address + "AI-LiNK冷暖风水专业集成系统定制方案",
                    share_img_url:
                        "https://aotest-lottery.iwxapi.com/core/images2020/watersystem/ant/share_img.png",
                    share_link: `${window.location.protocol}//${window.location.host}${window.location.pathname}?reportId=${this.$route.query.reportId}&nKey=${this.nKey}`,
                };
                this.confit = confit;
                getWxSingleConfig(confit);
                this.$store.commit("loadSwitch", false);
                if (this.$storage.getStorage("is_wechat") == 1) {
                    // 微信环境下
                    this.wxShareShow = true;
                } else if (this.$storage.getStorage("is_wechat") == 6) {
                    // 企业微信环境下
                    this.bShowNrom = true;
                }
            });
        },
        canler() {
            if (this.nNum != this.num && this.bComen) {
                this.num = this.nNum;
                this.value = this.nValue;
            } else if (!this.bComen) {
                this.num = 7;
                this.value = 100;
            }
            this.bShow = false;
        },
    },
};
</script>
<style lang="scss" scoped>
.no_state {
    height: 100vh;
    overflow: hidden;
}
.content {
    width: 100%;
    min-height: 100vh;
    padding-bottom: 120px;
    box-sizing: border-box;
    .pdfimg {
        img {
            pointer-events: none !important;
        }
    }
    .wxshare {
        position: fixed;
        z-index: 999;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.781);
        margin: auto;
        .wxContent {
            width: 100%;
            position: relative;
            margin-top: 70px;
            display: flex;
            flex-direction: column;
            align-items: flex-end;
        }
        .wxTips {
            width: 100%;
            margin-top: 200px;
            text-align: center;
            color: #fff;
            font-size: 40px;
        }
        img {
            margin-right: 20px;
            width: 50%;
        }
    }
    .overdue {
        position: fixed;
        z-index: 999;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.781);
        margin: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        .overdue_tips {
            width: 90%;
            height: 200px;
            background: #fff;
            border-radius: 20px;
            padding: 30px;
            box-sizing: border-box;
            .overdue_title {
                font-size: 34px;
                font-weight: 700;
                text-align: center;
            }
            .overdue_text {
                text-align: center;
                margin-top: 20px;
            }
        }
    }
    .share_mark {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        background: rgba(0, 0, 0, 0.705);
        display: flex;
        align-items: center;
        justify-content: center;
        .share_tips {
            width: 600px;
            background: #ffffff;
            border-radius: 16px;
            padding: 38px;
            box-sizing: border-box;
            .share_title {
                font-size: 34px;
                color: #333333;
                font-weight: 700;
                text-align: center;
            }
            .validity {
                display: flex;
                align-items: center;
                font-size: 28px;
                color: #333333;
                justify-content: center;
                margin-top: 36px;
                span {
                    padding: 3px 18px;
                    border: 1px solid #dbdbdb;
                    border-radius: 8px;
                }
            }
            .progress {
                width: 427px;
                margin: 30px auto;
            }
            .text {
                color: #818080;
                font-size: 24px;
                text-align: center;
            }
            .btn {
                display: flex;
                align-items: center;
                justify-content: space-around;
                margin-top: 30px;
                div {
                    width: 200px;
                    height: 80px;
                    border: 1px solid #333333;
                    border-radius: 40px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 34px;
                    &:first-child {
                        color: #fff;
                        border: 0px;
                        background: #6176e8;
                    }
                }
            }
        }
    }
    .borrom_btn {
        background: #fff;
        display: flex;
        align-items: center;
        border-top: 2px solid #000;
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        div {
            width: 50%;
            height: 120px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #333333;
            font-size: 34px;
            border-right: 2px solid #000;
            box-sizing: border-box;
            &:last-child {
                border-right: 0;
            }
        }
    }
}
::v-deep .van-image__img {
    pointer-events: none !important;
}
::v-deep .van-slider__button {
    background: #6176e8 !important;
    box-shadow: 0px 1px 4px 0px #adb9f8 !important;
}
</style>
